<template>
  <div class="menu">
    <div class="clearfix inner box">
      <div class="fl">
        <img src="../../assets/logo.png" alt="" />
      </div>
      <!-- <div class="fr">
        <span
          @click="handleRouter(item, index)"
          :class="{ current: index == index1 }"
          v-for="(item, index) in list"
          :key="index"
          >{{ item.text }}</span
        >
      </div>
    </div> -->
      <el-menu
        :default-active="activeIndex"
        class="fr"
        @select="handleSelect"
        router
        mode="horizontal"
        active-text-color="#0e9cf6"
      >
        <!-- <el-menu-item v-for="(item, i) in list" :key="i" :index="item.name">{{
          item.text
        }}</el-menu-item> -->
        <el-menu-item index="/home">首页</el-menu-item>
        <el-menu-item index="/resourceCenter">资源中心</el-menu-item>
        <el-menu-item index="/prepareLessons">我的备课</el-menu-item>
        <el-menu-item index="/homework">作业</el-menu-item>
        <el-menu-item index="/taskwork">任务</el-menu-item>
        <el-menu-item index="/testPaper">题库/组卷</el-menu-item>
        <!-- <el-menu-item index="/space">空间</el-menu-item> -->
        <el-submenu index="/space">
          <template slot="title">空间</template>
          <el-menu-item index="/space">我的空间</el-menu-item>
          <el-menu-item index="/space/infomalloc">申请空间</el-menu-item>
          <el-menu-item index="/space/Every">人人通空间</el-menu-item>
        </el-submenu>
        <el-menu-item index="/person">个人中心</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // list: [
      //   { text: "首页", name: "/home" },
      //   { text: "资源中心", name: "/resourceCenter" },
      //   { text: "我的备课", name: "/prepareLessons" },
      //   { text: "作业/任务", name: "/homework" },
      //   { text: "题库/组卷", name: "/testPaper" },
      //   { text: "空间", name: "/space" },
      //   // { text: "互动课堂", name: "/prepareLessons" },
      //   { text: "个人中心", name: "/person" },
      // ],
      // index1: "0",
      activeIndex: "/home",
    };
  },
  components: {},
  watch: {
    $route() {
      this.handleSelect(this.activeIndex);
    },
  },

  created() {
    this.activeIndex = this.$route.matched[0].path || "/";

    if (sessionStorage.getItem("current")) {
      this.index1 = sessionStorage.getItem("current");
    }
  },
  methods: {
    handleSelect(index) {
      this.activeIndex = index;
    },
    handleRouter(item, index) {
      // console.log(item.name)
      this.$router.push(`${item.name}`);
      this.index1 = index;
      sessionStorage.setItem("current", index);
    },
  },
};
</script>

<style lang='less' scoped>
.menu {
  background-color: #fff;
  .box {
    // height: 90px;
    // line-height: 90px;
    padding: 15px 0;
  }
  .el-menu {
    border-bottom: none;
    .el-menu-item {
      font-size: 16px;
      padding: 0 28px;
      color: rgb(88, 87, 87);
    }
    .el-submenu/deep/.el-submenu__title {
      font-size: 16px !important;
    }
  }

  // img {
  //   vertical-align: middle;
  // }
  // span {
  //   margin-left: 60px;
  //   cursor: pointer;
  // }
  // span:hover {
  //   color: #409eff;
  // }
  // .current {
  //   color: #409eff;
  //   padding-bottom: 10px;
  //   border-bottom: 3px solid #409eff;
  // }
}
</style>
